// @flow

import { Component } from '../jsti/core';
import { isLargeScreen } from '../classes/Helpers';
import EventNames from '../constants/EventNames';

export default class Scroll extends Component {
  #target: HTMLElement | null;

  /**
   * Initialize the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    const href = this.el.getAttribute('href');
    if (href) {
      this.#target = document.querySelector(href);
    }

    this.el.addEventListener(EventNames.CLICK, this.onClick.bind(this));
  }

  /**
   * Scroll to an element
   */
  scroll(element: HTMLElement | null = null, offset: number = 0): void {
    let target: HTMLElement = document.body;
    if (element) {
      target = element;
    }

    const headerOffset = () => {
      const header: HTMLElement | null = document.querySelector('header');
      if ((header && !header.classList.contains('scrolled')) || !element) {
        if (!isLargeScreen()) {
          return -60;
        }
        return 0;
      }
      return 20;
    };
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - (window.store.headerHeight + headerOffset());

    window.scrollTo({
      top: offsetPosition - offset
    });
  }

  /**
   * scrolls on click
   */
  onClick(event: Event): void {
    event.preventDefault();
    if (!this.#target) return;
    this.scroll(this.#target);
  }
}
